import { AuditTimeline } from '@/features/audit/audit-timeline'
import { useAuditLogQuery } from '@/features/audit/hooks/use-audit-log'
import { useUsersLookupQuery } from '@/features/users/hooks/use-users-query'
import { Skeleton } from '@/shared/ui/skeleton'

type FlowAuditTimelineProps = {
  flowId: string
  clientName: string
}

/**
 * Historial de un flujo individual, leído de la bitácora central (`portal_form_request`).
 * Resuelve el actor interno por su id y muestra la identidad del cliente en las filas del
 * cliente. Se usa tanto en el acordeón de "Flujos anteriores" como en el side panel de
 * detalle del flujo del hub del portal.
 */
export function FlowAuditTimeline({ flowId, clientName }: FlowAuditTimelineProps) {
  const { data: users = [] } = useUsersLookupQuery()
  const { data, isLoading, isError } = useAuditLogQuery('portal_form_request', flowId)

  const usersById = new Map(users.map((u) => [u._id, u.fullname]))
  const resolveActor = (id: string) => usersById.get(id) ?? 'Equipo interno'

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-12 w-full" />
      </div>
    )
  }

  if (isError) {
    return <p className="text-sm text-destructive">No se pudo cargar el historial.</p>
  }

  if (!data || data.items.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">Este flujo no tiene actividad registrada.</p>
    )
  }

  return (
    <AuditTimeline
      entries={data.items}
      resolveActor={resolveActor}
      client={{ name: clientName, photo: null }}
    />
  )
}
